const noOp = () => {}

const error = console.error

const log = noOp
const info = noOp
const warn = noOp

export const logger = {
  log,
  info,
  warn,
  error,
}
